var _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestPriceSticker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45L0 45V0Z",
    fill: "#ED1C24"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 15,
    transform: "rotate(-45 15 15)",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    fontWeight: "bold"
  }, "\n    BEST\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 23,
    transform: "rotate(-45 15 15)",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    fontWeight: "bold"
  }, "\n    PRICE\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestPriceSticker);
export default __webpack_public_path__ + "static/media/best-price-sticker.4f45096e19e3a6bb3dc7bc3a1657b9eb.svg";
export { ForwardRef as ReactComponent };